import { apiGet } from '@/lib/http/client';

import type { HubspotSyncHealthResponse } from '../types';

export async function getHubspotSyncHealth(
  orgId: number | string
): Promise<HubspotSyncHealthResponse> {
  return apiGet<HubspotSyncHealthResponse>(
    `/api/orgs/${orgId}/hubspot/sync-health/`
  );
}
